// utils/filterPhoneCountries.js
import { getCountries } from 'libphonenumber-js/core'
import metadata from 'libphonenumber-js/metadata.full.json'

/**
 * Фильтрует массив стран, оставляя только те, которые поддерживаются libphonenumber-js
 * @param {Array} countries - массив стран из API (с полем `iso`)
 * @returns {{ filtered: Array, isoList: string[] }}
 */
export function filterPhoneCountries(countries) {
    const supportedISOs = getCountries(metadata)

    const filteredCountries = countries.filter(country =>
        supportedISOs.includes(country.iso)
    )

    return {
        filtered: filteredCountries,
        isoList: filteredCountries.map(c => c.iso)
    }
}
